import React from 'react';

import Banner from './banner';

import withPageComponents from '../../page/components/with-page-components';

const HeroBanner = ({ productListingHeroBanner, ...props }) => {
    if (!productListingHeroBanner) return null;

    return <Banner banner={productListingHeroBanner} {...(props || {})} />;
};

export default withPageComponents(HeroBanner, { components: ['productListingHeroBanner'] });
